import { FieldObject } from '~/interfaces/field.interface';

export function batteryPercent(value?: number): FieldObject {
    return { key: 'Netatmo Battery (% registre)', value };
}

export function batteryVoltageMax(value ?: number): FieldObject {
    return { key: 'Netatmo Battery ADC max boost on', value };
}
export function batteryVoltageMin(value?: number): FieldObject {
    return { key: 'Netatmo Battery ADC min boost on', value };
}
export function soundTestReminder(value?: string): FieldObject {
    return { key: 'Sound test reminder', value, type: 'alert_record' };
}
export function notificationWifiConnection(value?: boolean): FieldObject {
    return { key: 'Wi-Fi connection succeeded notification', value };
}
